export const PERMISSIONS = {
  BOOKING_CREATE: "booking.create",
  BOOKING_READ: "booking.read",
  BOOKING_UPDATE: "booking.update",
  BOOKING_DELETE: "booking.delete",
  BOOKING_DOWNLOAD: "booking.download",

  CUSTOMER_CREATE: "customer.create",
  CUSTOMER_READ: "customer.read",
  CUSTOMER_UPDATE: "customer.update",
  CUSTOMER_DELETE: "customer.delete",
  CUSTOMER_DOWNLOAD: "customer.download",

  SITE_CREATE: "site.create",
  SITE_READ: "site.read",
  SITE_UPDATE: "site.update",
  SITE_DELETE: "site.delete",
  SITE_DOWNLOAD: "site.download",

  ORGANISATION_CREATE: "organisation.create",
  ORGANISATION_READ: "organisation.read",
  ORGANISATION_UPDATE: "organisation.update",
  ORGANISATION_DELETE: "organisation.delete",
  ORGANISATION_DOWNLOAD: "organisation.download",

  // User permissions
  USER_CREATE: "user.create",
  USER_READ: "user.read",
  USER_UPDATE: "user.update",
  USER_DELETE: "user.delete",

  COLLINS_UPDATE: "collins.update",
  COLLINS_MOBILE: "collins_mobile",
  MANAGE_COLLINS: "manage_collins",
  AUDIT_LOG_READ: "audit_log.read",
  AUDIT_LOG_DOWNLOAD: "audit_log.download",
  BANK_TRANSFER_READ: "bank_transfer.read",
  BANK_TRANSFER_DOWNLOAD: "bank_transfer.download",
  PAYMENT_READ: "payment.read",
  PAYMENT_DOWNLOAD: "payment.download"
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export const VENUE_GROUP_CAPABILITIES = {
  MANAGE_BOOKINGS: (venueGroupId: string) =>
    `manage_venue_group_bookings_${venueGroupId}`,
  VIEW_REPORTS: (venueGroupId: string) =>
    `view_venue_group_reports_${venueGroupId}`,
  DOWNLOAD_REPORTS: (venueGroupId: string) =>
    `download_venue_group_reports_${venueGroupId}`,
  VIEW_CUSTOMERS: (venueGroupId: string) =>
    `view_venue_group_customers_${venueGroupId}`,
  DOWNLOAD_CUSTOMERS: (venueGroupId: string) =>
    `download_venue_group_customers_${venueGroupId}`,
  MANAGE_PERMISSIONS: (venueGroupId: string) =>
    `manage_venue_group_permissions_${venueGroupId}`,
  MANAGE_VENUES: (venueGroupId: string) =>
    `manage_venue_group_venues_${venueGroupId}`,
  MANAGE_BOOKING_RULES: (venueGroupId: string) =>
    `manage_venue_group_booking_rules_${venueGroupId}`,
  MANAGE_REFUNDS: (venueGroupId: string) =>
    `manage_venue_group_refunds_${venueGroupId}`,
  DELETE_BOOKINGS: (venueGroupId: string) =>
    `delete_venue_group_bookings_${venueGroupId}`,
  CONFIRM_BOOKINGS: (venueGroupId: string) =>
    `confirm_venue_group_bookings_${venueGroupId}`
};

export const INDIVIDUAL_VENUE_CAPABILITIES = {
  MANAGE_BOOKINGS: (venueId: string) => `manage_venue_bookings_${venueId}`,
  CONFIRM_BOOKINGS: (venueId: string) => `confirm_venue_bookings_${venueId}`,
  VIEW_REPORTS: (venueId: string) => `view_venue_reports_${venueId}`,
  DOWNLOAD_REPORTS: (venueId: string) => `download_venue_reports_${venueId}`,
  VIEW_CUSTOMERS: (venueId: string) => `view_venue_customers_${venueId}`,
  MANAGE_BOOKING_RULES: (venueId: string) =>
    `manage_venue_booking_rules_${venueId}`,
  MANAGE_PERMISSIONS: (venueId: string) => `manage_venue_permissions_${venueId}`
};

export const EVENT_CAPABILITIES = {
  ACCESS_EVENTS_ADMIN: "access_events_admin",
  ADD_EVENTS: "add_events",
  HAS_EARLY_ACCESS_PREVIEW: "has_early_access_preview",
  EVO_EARLY_ADOPTER: "evo_early_adopter",
  ADD_EVENT_BRANDS: "add_event_brands",
  ACCESS_TONIC_EVENTBRANDS: "access_tonic_eventbrands"
} as const;

export const EMAIL_DOMAINS = {
  THE_ACCESS_GROUP: "theaccessgroup",
  DESIGN_MY_NIGHT: "@designmynight.com"
};
